"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentPosition = void 0;
var utils_1 = require("../utils");
// 默认的位置定位结果
var positionResultDefault = {
    status: false,
    code: 'UNKNOWN_ERROR',
    type: '',
    data: {
        latitude: '',
        longitude: ''
    }
};
/**
 * 通过H5定位
 */
var h5 = function () {
    var geolocation = window && window.navigator && window.navigator.geolocation;
    var result = positionResultDefault;
    if (!geolocation) {
        result.code = 'NOT H5 ENVIRONMENT';
        return Promise.resolve(result);
    }
    return new Promise(function (resolve) {
        return geolocation.getCurrentPosition(function (r) {
            /**
             * result包含两个属性 coords 和 timestamp。其中 coords 属性包含以下7个值：
             * accuracy：精确度
             * latitude：纬度
             * longitude：经度
             * altitude：海拔
             * altitudeAcuracy：海拔高度的精确度
             * heading：朝向
             * speed：速度
             */
            r.coords &&
                r.coords.latitude &&
                r.coords.longitude &&
                (result = {
                    status: true,
                    code: 'OK',
                    type: 'WGS84',
                    data: {
                        latitude: String(r.coords.latitude),
                        longitude: String(r.coords.longitude)
                    }
                });
            return resolve(result);
        }, function (error) {
            /**
             * 包含两个属性message, code
             * error.code (错误码)
             * PERMISSION_DENIED - 用户不允许地理定位
             * POSITION_UNAVAILABLE - 无法获取当前位置
             * TIMEOUT - 操作超时
             * UNKNOWN_ERROR- 未知错误
             */
            if (error.code && error.code === error.PERMISSION_DENIED) {
                result.code = 'DENIED';
            }
            else {
                result.code = error.code + "-H5 FAILED";
            }
            return resolve(result);
        }, {
            // 是否启用高精确度模式，如果启用这种模式，浏览器在获取位置信息时可能需要耗费更多的时间
            enableHighAccuracy: true,
            // 超时时间，浏览需要在指定的时间内获取位置信息，否则触发errorCallback
            timeout: 5000,
            // 最长有效期，在重复获取地理位置时，此参数指定多久再次获取位置。表示浏览器重新获取位置信息的时间间隔
            maximumAge: 0
        });
    });
};
// 获取百度地图sdk、动态注入百度地图JS
var getbdmapSDK = function (bdAK) {
    if (window && !window.BMap) {
        window.BMap = {};
        window.BMap._preloader = new Promise(function (resolve) {
            var $script = document.createElement('script');
            window.initBaiduMap = function () {
                resolve(window.BMap);
                window.document.body.removeChild($script);
                window.BMap._preloader = null;
                window.initBaiduMap = null;
            };
            $script.src = "//api.map.baidu.com/api?v=2.0&ak=" + bdAK + "&callback=initBaiduMap";
            window.document.body.appendChild($script);
        });
        return Promise.resolve(window.BMap._preloader);
    }
    return Promise.resolve(window && window.BMap);
};
// 通过百度地图定位
var bdmap = function (bdAK) {
    var result = positionResultDefault;
    if (!bdAK) {
        result.code = 'MISS BDAK';
        console.warn('miss bdAK');
        return Promise.resolve(result);
    }
    return new Promise(function (resolve) {
        getbdmapSDK(bdAK)
            .then(function (BMap) {
            var bmapGeolocation = new BMap.Geolocation();
            bmapGeolocation.getCurrentPosition(function (r) {
                result.code = 'BDMAP FAILED';
                parseInt(bmapGeolocation.getStatus()) === 0 &&
                    r.point &&
                    (result = {
                        status: true,
                        code: 'OK',
                        type: 'BD09',
                        data: {
                            latitude: String(r.point.lat) || '',
                            longitude: String(r.point.lng) || ''
                        }
                    });
                // 用户拒绝授权定位功能
                parseInt(bmapGeolocation.getStatus()) === 6 && ((result.status = true), (result.code = 'DENIED'));
                return resolve(result);
            }, {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0 // 允许返回指定时间内的缓存结果。如果此值为0，则浏览器将立即获取新定位结果
            });
        })
            .catch(function () {
            return resolve(result);
        });
    });
};
/**
 * 微信小程序内置定位
 * @param wx 微信sdk对象
 */
var wxapp = function () {
    var result = positionResultDefault;
    if (typeof wx === 'undefined' || !wx.getLocation) {
        result.code = 'NOT WXAPP ENVIRONMENT';
        return Promise.resolve(result);
    }
    return new Promise(function (resolve) {
        if (typeof wx !== 'undefined' && wx.getLocation) {
            return wx.getLocation({
                type: 'gcj02',
                success: function (res) {
                    // longitude  经度，浮点数，范围为180 ~ -180。
                    // latitude 纬度，浮点数，范围为90 ~ -90
                    // speed 速度，以米/每秒计
                    // accuracy  位置精度
                    result = {
                        status: true,
                        code: 'OK',
                        type: 'GCJ02',
                        data: {
                            latitude: String(res.latitude),
                            longitude: String(res.longitude)
                        }
                    };
                    return resolve(result);
                },
                cancel: function () {
                    // 用户点击拒绝授权
                    result.code = 'DENIED';
                    return resolve(result);
                },
                fail: function () {
                    // 定位失败
                    result.code = 'WXAPP FAILED';
                    return resolve(result);
                }
            });
        }
        resolve(result);
    });
};
/**
 * 获取当前定位方法的初始化参数
 */
var defaultConfig = {
    // 是否通过原生H5/百度地图/谷歌地图/微信SDK定位
    h5: true,
    bdmap: true,
    ggmap: false,
    wxapp: true
};
exports.getCurrentPosition = function (config) {
    if (config === void 0) { config = defaultConfig; }
    return __awaiter(void 0, void 0, void 0, function () {
        /**
         * 不同环境定位检测pipe，优先级sdk定位-第三方（百度等）-原生h5
         */
        function checkResult(way, fn) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // 定位成功或者用户禁止授权则终止pipe
                            if (positionResult.code === 'OK' || positionResult.code === 'DENIED')
                                return [2 /*return*/];
                            if (!_config[way]) return [3 /*break*/, 2];
                            return [4 /*yield*/, fn.apply(null, args)];
                        case 1:
                            positionResult = _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        var _config, positionResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _config = __assign(__assign({}, defaultConfig), config);
                    positionResult = {
                        status: false,
                        code: '',
                        type: '',
                        data: {
                            latitude: '',
                            longitude: ''
                        }
                    };
                    return [4 /*yield*/, checkResult('wxapp', wxapp)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, checkResult('bdmap', bdmap, _config.bdAK)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, checkResult('h5', h5)
                        /** 转换目标坐标系 */
                    ];
                case 3:
                    _a.sent();
                    /** 转换目标坐标系 */
                    if (_config.type) {
                        positionResult.data = utils_1.transCoordSys(positionResult.type, _config.type, positionResult.data);
                        positionResult.type = _config.type;
                    }
                    return [2 /*return*/, positionResult];
            }
        });
    });
};
exports.default = (function (UIP) {
    UIP.checkModule('interface', 'geo', 'location');
    UIP.interface.geo.location = {
        getCurrentPosition: exports.getCurrentPosition,
        h5: h5,
        bdmap: bdmap,
        wxapp: wxapp
    };
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-geo/dist/location/index.js
// module id = dg2e
// module chunks = 1